import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Container, Typography } from '@mui/material';
import { ResetPassword } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const PasswordResetConfirmPage: React.FC = () => {
    const { uid, token } = useParams<{ uid: string; token: string }>();
    const [newPassword, setNewPassword] = useState<string>('');
    const [reNewPassword, setReNewPassword] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const navigate = useNavigate();
    const { refreshTokenFunction, logout, token: authToken } = useAuth();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if (uid && token) {
                await ResetPassword(newPassword, reNewPassword, uid, token);
                setMessage('パスワードが変更されました。');
                navigate('/');
            } else {
                setMessage('UIDとトークンが無効です。');
            }
        } catch (error: any) {
            // 401の場合はリフレッシュトークンで再取得を試みる
            if (error.response && error.response.status === 401) {
                try {
                    const newToken = await refreshTokenFunction();
                    if (newToken && uid) {
                        await ResetPassword(newPassword, reNewPassword, uid, newToken);
                        setMessage('パスワードが変更されました。');
                        navigate('/');
                        return;
                    }
                } catch (refreshError) {}
            }
            setMessage('エラーが発生しました。もう一度お試しください。');
            logout();
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    mt: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="h6" component="div">
                    パスワードの変更
                </Typography>
                <TextField
                    label="新しいパスワード"
                    type="password"
                    variant="outlined"
                    fullWidth
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <TextField
                    label="新しいパスワード（確認）"
                    type="password"
                    variant="outlined"
                    fullWidth
                    value={reNewPassword}
                    onChange={(e) => setReNewPassword(e.target.value)}
                    required
                />
                {message && (
                    <Typography variant="body2" color="textSecondary">
                        {message}
                    </Typography>
                )}
                <Button type="submit" variant="contained" color="primary">
                    パスワードを変更
                </Button>
                <Button variant="outlined" color="secondary" onClick={() => navigate('/')}>
                    戻る
                </Button>
            </Box>
        </Container>
    );
};

export default PasswordResetConfirmPage;
